<template>
  <div class="row col-12 text-weight-bold">
    <div class="col-12 q-mt-xs">
      <div class="q-mb-xs">Mudar Para</div>
      <q-select
        dense
        outlined
        v-model="status"
        :options="listaStatus"
        use-input
        input-debounce="0"
        hide-selected
        fill-input
        option-label="label"
        option-value="value"
      >
      </q-select>
    </div>
    <div class="col-12 q-mt-xs">
      <SelectComponentFornecedores
        @emitirFornecedor="receberFornecedor"
        :reset="resetar"
      />
    </div>
    <div class="col-12 q-mt-xs">
      <div class="q-mb-xs">Observação</div>
      <q-input dense outlined v-model="observacao"> </q-input>
    </div>

    <div class="row col-12 justify-end">
      <p></p>
      <q-btn
        class="q-mt-md"
        color="primary"
        no-caps
        dense
        icon="add_circle_outline"
        label="Adicionar"
        @click="salvar()"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelectComponentFornecedores from "./SelectComponentFornecedores.vue";

export default {
  name: "SelectComponentStatus",
  components: { SelectComponentFornecedores },
  emits: ["emitirStatus"],
  props: ["uuid", "statusAtual"],

  setup(props, { emit }) {
    const $q = useQuasar();
    const store = useStore();
    const status = ref("");
    const observacao = ref("");
    const resetar = ref(0);
    const fornecedor = ref("");

    let salvar = async () => {
      await movimentaStatus();
    };

    let emitirStatus = async (status) => {
      emit("selectValue", status);
    };

    const movimentaStatus = async () => {
      if (
        props.statusAtual === "em_transito" ||
        props.statusAtual === "Em Trânsito"
      ) {
        $q.notify({
          message: "Não é possivel movimentar a ferramenta nesse status.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("fer/movimentaStatus", {
          uuid: props.uuid,
          status: status.value?.value,
          observacao: observacao.value,
          fornecedor_id: fornecedor.value?.id,
        });

        $q.notify({
          message: "Status alterado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        await emitirStatus(status);
      } catch (error) {
        $q.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    emit("selectValue", status);
    const listaStatus = ref([
      { label: "Disponível", value: "disponivel" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Aguardando Revisão", value: "aguardando_revisao" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);

    const receberFornecedor = (value) => {
      if (value.value.id === "") {
        fornecedor.value = "";
        return;
      }
      fornecedor.value = value.value;
    };

    watch(
      () => props.uuid,
      () => {
        resetar.value++;
      }
    );

    return {
      listaStatus,
      status,
      observacao,
      emitirStatus,
      movimentaStatus,
      salvar,
      receberFornecedor,
      resetar,
      fornecedor,
    };
  },
};
</script>
